const options = {
  5: "bg-pink-100/5",
  10: "bg-pink-100/10",
  25: "bg-pink-100/25",
  50: "bg-pink-100/50",
  75: "bg-pink-100/75",
  90: "bg-pink-100/90",
  100: "bg-pink-100",
};

const from = {
  5: "from-pink-100/5",
  10: "from-pink-100/10",
  25: "from-pink-100/25",
  50: "from-pink-100/50",
  75: "from-pink-100/75",
  90: "from-pink-100/90",
  100: "from-pink-100",
};

export default function getBackgroundPink100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
